export default __webpack_public_path__ + "static/media/Background_00091.6085f02e.png";